module.exports = __webpack_public_path__ + "img/bart.ecc2798.webp";